import { BaseModel, Guid, RecursivePartial } from '@models/base';

export class TaskCumulativeFlowData extends BaseModel {
    stateId?: Guid;        // workflow state id
    count?: number;        // количество задач в этом статусе
    date?: Date;             // дата на которую посчитан count

    constructor(json?: RecursivePartial<TaskCumulativeFlowData>) {
        super(json);
        this.parseTaskCumulativeFlowData(json || {});
    }

    parse(json: RecursivePartial<TaskCumulativeFlowData>): TaskCumulativeFlowData {
        super.parse(json);
        this.parseTaskCumulativeFlowData(json);
        return this;
    }

    private parseTaskCumulativeFlowData(json: RecursivePartial<TaskCumulativeFlowData>): void {
        TaskCumulativeFlowData.assignFields(this, json, ['stateId', 'count']);
        TaskCumulativeFlowData.assignDates(this, json, ['date']);
    }

}
